import { Button, PDFViewer, Panel, Typography } from "@/components/atoms";
import TermsAndConditionsPDF from "@/assets/templates/terms-and-conditions.pdf";

export const TermsAndConditions = () => {
  const handleDownloadClick = () => {
    window.open(TermsAndConditionsPDF, "_blank");
  };

  return (
    <Panel>
      <div className="flex items-center gap-4">
        <div className="flex-1">
          <Typography variant="h3">RideMinder Platform Usage Subscription Agreement</Typography>
        </div>
        <div className="flex">
          <Button variant="tertiary" startIcon="ImportCurve" className="ml-2 text-info" onClick={handleDownloadClick}>
            Download PDF
          </Button>
        </div>
      </div>
      <div className="min-h-[500px]">
        <PDFViewer src={TermsAndConditionsPDF} className="mt-4 min-h-[70vh] w-full" />
      </div>
    </Panel>
  );
};
